export default "__VITE_ASSET__Ijs_kLOL__"